module.exports = __webpack_public_path__ + "img/CZ.047e732d.svg";